import axios from 'axios';
import { get } from 'lodash';

export const attributes = () =>
  axios
    .post('/api/ds-attribute', { op: 'list' })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const createAttribute = values =>
  axios
    .post('/api/ds-attribute', {
      op: 'create',
      item: values,
    })
    .then(response => ({
      data: response.data,
      success: get(response, 'data.id', false) ? true : false,
    }))
    .catch(error => ({ success: false }));

export const updateAttribute = (id, data) =>
  axios
    .post('/api/ds-attribute', { op: 'update', item: { id, ...data } })
    .then(response => ({
      data: response.data,
      success: get(response, 'data.id', false) ? true : false,
    }))
    .catch(error => ({ success: false }));

export const getAttribute = id =>
  axios
    .post('/api/ds-attribute', { op: 'read', convert: true, item: { id } })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const getAttributeValue = id =>
  axios
    .post('/api/ds-attribute-value', { order: 'value', op: 'read', convert: true, item: { id } })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const addAttributeValue = (attributeId, data) =>
  axios
    .post('/api/ds-attribute-value', { op: 'create', item: { attributeId, ...data } })
    .then(response => ({
      data: response.data,
      success: get(response, 'data.id', false) ? true : false,
    }))
    .catch(error => ({ success: false }));

export const updateAttributeValue = data =>
  axios
    .post('/api/ds-attribute-value', { op: 'update', item: data })
    .then(response => ({
      data: response.data,
      success: get(response, 'data.id', false) ? true : false,
    }))
    .catch(error => ({ success: false }));

export const deleteAttribute = id =>
  axios
    .post('/api/ds-attribute', { op: 'delete', item: { id } })
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));

export const deleteAttributeValue = id =>
  axios
    .post('/api/ds-attribute-value', { op: 'delete', item: { id } })
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/attributes/_api.js